export default [
  {
    path: "/test/index",
    name: "index",
    component: () => import("@/views/test/index"),
    meta: {
      title: ""
    }
  },
  {
    path: "/test/pdf",
    name: "pdf",
    component: () => import("@/views/test/pdf"),
    meta: {
      title: ""
    }
  },
  {
    path: "/test/vuePdf",
    name: "vuePdf",
    component: () => import("@/views/test/vuePdf"),
    meta: {
      title: ""
    }
  }
];
